
// Own Targets
import {ArrayX} from "@/reusable/array_extensions";

export class Ziele {
    constructor(targets) {
        this.targets = targets;
    }

    static makeId(year){
        return ""+ year;
    }

    getCurrentTargets() {
        return this.getTargets(Date.now())
    }

    getTargets(date) {
        var date1=new Date(date);
        if (!this.targets || !this.targets.Dates)
            return undefined;
        var pastValues=this.targets.Dates.filter(x=> new Date(x.Date) <= date1);
        return pastValues[0];
    }

    AddTargets(targets) {
        console.log("AddTargets:", {targets});
        var DatesCopy = [...this.targets.Dates];
        DatesCopy.push(targets);
        this.targets.Dates=[];
        var lastDate=undefined;
        new ArrayX( DatesCopy).sortBy(x=>new Date(x.Date), true).forEach(values => {
            if (lastDate===values.Date)
                return;
            lastDate=values.Date;
            this.targets.Dates.push(values);
        });
    }
}